Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SessionTabView extends Backbone.View
  template: JST['backbone/templates/monitoring/sessions/session_tab']
  tagName: 'li'
  className: 'session'

  events:
    'click .tab': 'onClickOnTab'
    'click .badge': 'onUpdateContentsCount'
    'click #minimize_tab': 'onMinimizeTab'
    'click #minimize_tab_new_session': 'onMinimizeNewTab'
    'click #minimize_tab_drill_down': 'onMinimizeNewTab'
    'click .copy_session_from_tab': 'copySession'
    'click .clone_session_from_tab': 'cloneSession'
    'click .copy_session_id_from_tab': 'copySessionId'
    'click .remove_session_from_tab': 'removeSession'
    'click .rename_session_from_tab': 'renameSession'
    'mouseleave ul.dropdown-menu' : 'onMouseLeaveDropdownMenu'
    'click .dropdown': 'onClickMenu'

  initialize: (@options = {}) ->
    @dashboard = @options.dashboard
    @session = @options.session
    @listenTo(@dashboard, 'new_search', @onChangeMode)
    @is_new_tab = false
    @sessionsView = @options.sessionsView
    if `this.dashboard.searchQuery == null` then @is_new_tab = true
    @name = @options.name or I18n.t('monitoring.dashboard.session.tab.placeholder')
    @_renameTooltip(@name)
    @id = "minimize_tab"
    @id += "_new_session" if @name == I18n.t('monitoring.dashboard.session.tab.placeholder')
    @id += "_drill_down" if @name == "Drill Down"
    @eventAggregator.bind('onNewRealtimeContent', @onNewRealtimeContent)
    @eventAggregator.bind('contentReceived', @onContentReceived)
    @eventAggregator.bind('myHistorySessionCreated', @onMyHistorySessionCreated)
    @isActivated = false
    @listenTo(Backbone, 'session:tab:rename', @renameByUuid)

  onChangeMode: ({mode}) ->
    @sessionMode = mode
    @_renderSessionIcon(@sessionMode, @dashboard.searchQuery.toJSON())

  onClickOnTab: =>
    if !@isActivated
      if @dashboard.isReviewMode()
        $('.monitoring-dashboard').addClass('review').removeClass('explore')
      else
        $('.monitoring-dashboard').addClass('explore').removeClass('review')
      @eventAggregator.trigger('clickOnTab', this)
    window.scrollTo(0, 0)

  onMinimizeTab: (event) =>
    event.stopPropagation()
    @eventAggregator.trigger('clickOnMinimizeTab', this)

  onMinimizeNewTab: (event) =>
    if @$el.find('#name').text() == I18n.t('monitoring.dashboard.session.tab.placeholder')
      @onMinimizeTab(event)
    else if @$el.find('#name').text() == "Drill Down"
      @eventAggregator.trigger('clickOnMinimizeAndRemoveSession', this)
    else
      swal({
          title: I18n.t('monitoring.dashboard.session.tab.title'),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: I18n.t('monitoring.dashboard.session.tab.confirm'),
          confirmButtonClass: "btn-info"
          cancelButtonText: I18n.t('monitoring.dashboard.session.tab.cancel'),
          cancelButtonColor: "#DD6B55"
          closeOnConfirm: true,
          closeOnCancel: true
        }, (isSaved) =>
          if isSaved
            event.stopPropagation()
            @eventAggregator.trigger('clickOnMinimizeTab', this)
          else
            @eventAggregator.trigger('clickOnMinimizeAndRemoveSession', this)
      )

  onClickMenu: ->
    buttonContainer = @$el.find('.dropdown.tab-menu-button-container')
    dropdownToggle = @$el.find(".dropdown-toggle")
    dropdownMenu = @$el.find(".dropdown-menu")
    dropdownMenu.css({
      "top": (dropdownToggle.position().top + dropdownToggle.outerHeight()) + "px",
      "left": dropdownToggle.position().left + "px"
    });

  onContentReceived: (uuid) =>
    if @dashboard.uuid == uuid
      @$el.find('.badge').html('').hide() unless @dashboard.isReviewMode()
      @onUpdateContentsCount() if @dashboard.isReviewMode()

  onNewRealtimeContent: (uuid, counter) =>
    if @dashboard.uuid == uuid
      @$el.find('.badge').html(counter).show()

  onMyHistorySessionCreated: (uuid) =>
    if @dashboard.uuid == uuid
      window.myHistoryCreated = true
      @eventAggregator.trigger('addNewTab')
      @eventAggregator.trigger('clickOnMinimizeTab', this)

  render: =>
    @$el.append(jQuery.parseHTML(@template(
      name: @name
      id: @id
      is_new_tab: @is_new_tab
    )))
    @_renameTooltip(@name)
    @renderIconWith(@session) if @session
    return this

  renderIconWith: (session) =>
    query = JSON.parse(session.query)
    mode = 'explore'
    mode = 'analysis' if query.analysisMode
    mode = 'review' if query.reviewMode

    @_renderSessionIcon(mode, query)

  updateCount: (total) ->
    if @dashboard.isReviewMode()
      @$el.find('.badge').html(total).show()
      @onUpdateContentsCount() if @dashboard.isReviewMode()

  rename: (newName) ->
    @_renameTooltip(newName)
    options = @_getEditableOptions();
    dataToSend =
      value: newName
      pk: options.pk
    onSuccess = (response, msg) =>
      options.success(response, newName)
      @$el.find('#name').text(newName)
      @_renameTooltip(newName)
      @re_render(newName)
    $.ajax(
      type: 'POST',
      url: options.url,
      data: dataToSend,
      success: onSuccess
    )

  _renameTooltip: (name) ->
    return unless name and name.trim() != ''
    @$el.find('.tab').tooltip('hide').attr('data-original-title', name.trim()).tooltip('fixTitle')

  reRenderTitle: (name) =>
    @$el.find('#name').text(name)

  re_render: (name) =>
    @$el.html(@template({ name: name, id: @id, is_new_tab: false}))
    @_renderSessionIcon(@sessionMode, @dashboard.searchQuery.toJSON())
    @

  resize: ->
    throw "Monitoring.Views.SocialContents.SessionTabView.resize() deprecated"

  _getEditableOptions: ->
    return {
      type: 'text',
      pk: @getUuid(),
      display: @reRenderTitle,
      value: @name,
      toggle: 'manual',
      url: '/monitoring/dashboard/rename.json',
      title: I18n.t('monitoring.dashboard.session.tab.enter_name'),
      placement: 'bottom',
      success: (response, newValue) =>
        if !response.success
          return response.msg
        else
          @eventAggregator.trigger('sessionListChange')
          @dashboard.rename(newValue)
          @_renameTooltip(newValue)
    }

  activate: ->
    @dashboard.activate()
    @isActivated = true
    @$el.addClass('active')

  deactivate: ->
    if @isActivated
      @dashboard.deactivate()
      @isActivated = false
      @$el.removeClass('active')

  destroy: ->
    @dashboard.destroy()
    this.remove()
    return false

  getUuid: ->
    return @dashboard.uuid

  onUpdateContentsCount: ->
    $.ajax
      url: "/monitoring/dashboard/realtime_count/"
      type: 'POST'
      data:
        uuid: @getUuid()
      global: false
      success: (data) =>
        @updateBadge(data)
      dataType: "json"

  updateBadge: (data) =>
    @$el.find('.badge').html(data["counters"]["enqueued_count"]).show()
    popoverText = "Total: " + data["counters"]["enqueued_count"]
    popoverText += " - Blocked: " + data["counters"]["blocked_count"] if data["counters"]["blocked_count"] != undefined
    @$el.find('.badge-count-container i')[0].setAttribute("data-content", popoverText)
    window.load_popovers()

  copySession: (event) =>
    session = this.dashboard.session
    body_before = document.body
    copySessionModal = new Monitoring.Views.SocialContents.CopySessionView(session: session).render()
    copySessionModal.bind 'onSuccess', (response) =>
      document.body.children.copy_session.remove()
      while (document.body.children.copy_session)
        document.body.children.copy_session.remove()
      document.getElementsByClassName("modal-backdrop")[0].remove()
    $($(copySessionModal.$el.find('.users'))).css('padding-left','10px')
    copySessionModal.show().appendTo("body")

  removeSession: (event) =>
    event.stopPropagation()
    swal({
        title: I18n.t('monitoring.dashboard.session.modal_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: I18n.t('monitoring.dashboard.session.s_yes'),
        cancelButtonText: I18n.t('monitoring.dashboard.session.s_cancel'),
        closeOnConfirm: true
      }, =>
        @eventAggregator.trigger('clickOnRemoveSession', this.dashboard.session)
      )

  restoreSession: (event) =>
    @eventAggregator.trigger('clickOnRestoreSession', this.dashboard.session, => @trigger('destroyFromRestore'))

  cloneSession: (event) =>
    event.stopPropagation()
    this.$el.find('.dropdown-menu').click()
    @session = this.dashboard.session
    $.ajax
      url: "/monitoring/sessions/#{@session.uuid}/clone"
      data: JSON.stringify({
        users_ids: [@session.user_id]
      })
      type: 'POST'
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) =>
        session = response.session
        @eventAggregator.trigger('sessionListChange')
        @eventAggregator.trigger('clickOnRestoreSession', session , => @trigger('destroyFromRestore'))

  copySessionId: (event) =>
    sessionId = @dashboard.uuid
    @copyText(sessionId)
      .then =>
        showSuccess("#{I18n.t('monitoring.dashboard.session.tab.copied')}!")
      .catch (err) ->
        console.error('Error al copiar:', err)
        console.log('Session ID:', sessionId)

  renameSession: (event) =>
    event.stopPropagation()
    this.$el.find('.dropdown-menu').click()
    @$el.editable(@_getEditableOptions())
    @$el.editable('toggle')
    @$el.find('.tab').tooltip({ 'placement': 'bottom' })

  onMouseLeaveDropdownMenu: ->
    @$el.find('.dropdown').removeClass('open')

  _renderSessionIcon: (mode, serializedSearchQuery) ->
    @vueSessionIcon = new VueInBackbone.VueComponent(
      'session-mode-icon',
      {
        mode: mode,
        searchQuery: serializedSearchQuery
      }
    )
    @$el.find('#mode-icon').html(@vueSessionIcon.el)
    @vueSessionIcon.render()

  renameByUuid: (uuid, newName) ->
    @rename(newName) if @getUuid() == uuid

  delete: ->
    @vueSessionIcon.destroy() if @vueSessionIcon

  copyText: (text) ->
    new Promise (resolve, reject) ->
      if navigator.clipboard and window.isSecureContext
        navigator.clipboard.writeText(text).then(resolve).catch(reject)
      else
        try
          temp = $('<textarea>')
          $('body').append(temp)
          temp.val(text).select()
          document.execCommand('copy')
          temp.remove()
          resolve()
        catch err
          reject(err)
